import { useCallback, useState } from 'react';

const getFaviconUrl = (websiteUrl?: string): string | undefined => {
	if (!websiteUrl?.trim()) return undefined;

	try {
		const { hostname } = new URL(websiteUrl.includes('://') ? websiteUrl : `https://${websiteUrl}`);
		return hostname ? `https://www.google.com/s2/favicons?domain=${hostname}&sz=128` : undefined;
	} catch {
		return undefined;
	}
};

export const useFaviconApi = (url?: string) => {
	const [faviconFailed, setFaviconFailed] = useState(false);

	const faviconUrl = getFaviconUrl(url);
	const showFavicon = !!faviconUrl && !faviconFailed;

	const handleFaviconError = useCallback(() => setFaviconFailed(true), []);

	return {
		showFavicon,
		handleFaviconError,
		faviconUrl,
	};
};
